import { useEffect, useState } from "react";

import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  getAccountType,
  getFundChoices,
  getKycDetails,
  getMasterData,
  getNomineeList,
  getPersonalDetails,
  getSchemeDetails,
  saveBasicDetails,
  saveKycDetails,
  savePersonalDetails,
  getDetailsFromPincode,
  getBankDetails,
} from "../../../../store/actions/newSubscriber";
import {
  dateToDDMMYYY,
  replaceDashToSlash,
  formatDate,
} from "../../../../utils/common";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import {
  setAccountTypes,
  setBankDetails,
  setBasicDetails,
  setKycDetails,
  setNomineeDetails,
  setPersonalDetails,
  setSchemeDetails,
  setStatusBackToSummary,
} from "../Context/NewSubscriberAction";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";

import { _getOptions } from "./util/getOptions";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormTextInput from "./lib/formik/InputField";
import FormDateInput from "./lib/formik/DateField";
import { useRef } from "react";
import FormRadioGroup from "./lib/formik/RadioGroup";
import FormSelectInput from "./lib/formik/inputSelectField";
import { SUCCESS_RESPONSE_CODE } from ".";

const PersonalDetails = () => {
  const dispatch = useDispatch();
  const {
    dob,
    refId,
    pan,
    ackNumber,
    mobileNumber,
    email,
    kycDetails,
    kycTrack,
    EKYCDetails,
    personalDetails,
    kycBankDetails,
    dispatch: dispatchContext,
    isBackToSummary,
    ResidenceType,
    Nationality,
    AAAdetails,
    skipKyc,
  } = useNewSubscriberContext();
  const { DtData: kycKtrackDetails } = kycTrack;
  const EKYCdata = EKYCDetails?.data?.result?.PERSONAL_DETAILS || {};

  const history = useHistory();

  const data = personalDetails?.data || {};

  const {
    Address1,
    Addreess2,
    CountryName,
    DOB,
    District,
    Gender,
    IdentifierType: aadhaarIdentifierType,
    IdentifierNum,
    PinCode,
    StateName,
    SubscriberName,
  } = AAAdetails || {};

  useEffect(() => {
    const setOptions = async () => {
      try {
        let pDetailsResponse = null;
        if (+personalDetails?.statusCode !== SUCCESS_RESPONSE_CODE) {
          //call API
          pDetailsResponse = await dispatch(getMasterData());
        }
        if (
          +personalDetails?.statusCode === SUCCESS_RESPONSE_CODE ||
          +pDetailsResponse?.statusCode === SUCCESS_RESPONSE_CODE
        ) {
          const {
            ResidentTypeList = [],
            GenderList = [],
            CountryList = [],
            PranTitlesList = [],
            MaritalStatusList = [],
            lstOccupationDetails = [],
          } = personalDetails?.data || pDetailsResponse?.data;
          setResidentTypeList(_getOptions(ResidentTypeList, "ID"));
          setOccupationOptions(_getOptions(lstOccupationDetails, "PK_ID"));
          setCountryList(_getOptions(CountryList, "PK_ID"));
          setGenderOptions(
            _getOptions(GenderList, "PK_ID").filter(
              (gender) => gender.label !== "Transgender"
            )
          );
          setMaritalStatusOptions(_getOptions(MaritalStatusList, "ID"));
          setPranNameOption(_getOptions(PranTitlesList, "ID"));
        }
      } catch (error) {
        alert(error);
        console.error(error);
      }
    };
    setOptions();
  }, []);

  useEffect(() => {
    async function fetchPersonalDetails() {
      const response = await dispatch(
        getPersonalDetails({ AckNumber: ackNumber })
      );
      if (Number(response?.statusCode) === SUCCESS_RESPONSE_CODE) {
        dispatchContext(setPersonalDetails(response));
      }
    }

    if (!!ackNumber) {
      fetchPersonalDetails();
    }
  }, [dispatch, ackNumber, dispatchContext]);

  const goBack = () => {
    history.push({
      pathname: "/nps/AddSubs/kyc-details",
    });
  };

  const [residentTypeList, setResidentTypeList] = useState([]);
  const [occupationOptions, setOccupationOptions] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [maritalStatusOptions, setMaritalStatusOptions] = useState([]);
  const [pranNameOptions, setPranNameOption] = useState([]);
  let dobb = DOB
    ? DOB
    : EKYCdata?.DOB || dob || data?.DOB
    ? EKYCdata?.DOB || dob || data?.DOB
    : kycKtrackDetails.dob
    ? new Date(parseInt(kycKtrackDetails.dob.substr(6)))
    : kycDetails?.DOB
    ? dob
    : "";
  if (dobb instanceof Date) {
    dobb = dateToDDMMYYY(dobb);
  } else if (dobb.includes("-")) {
    dobb = replaceDashToSlash(dobb, "-", "/");
  }

  const _residenceStatus =
    data?.ResidenceType || ResidenceType || kycDetails?.CountryName === "IN"
      ? "1"
      : "";
  const initialValues = {
    status: _residenceStatus,
    pan: pan || EKYCdata?.PAN,
    dob: formatDate(dobb),
    mobile:
      data?.Mobile ||
      EKYCdata?.MOB_NUM ||
      mobileNumber ||
      kycKtrackDetails?.mobile ||
      "",
    email:
      data?.Email || EKYCdata?.EMAIL || email || kycKtrackDetails?.email || "",
    name:
      data?.Name ||
      EKYCdata?.FULLNAME ||
      kycDetails?.SubscriberName ||
      SubscriberName ||
      "",
    occupation: data?.Occupation || "",
    place: data?.CityofBirth || "",
    nationality: data?.Nationality || Nationality || "",
    country:
      _residenceStatus === "1"
        ? "IN"
        : EKYCdata?.PERM_COUNTRY ||
          kycDetails?.CountryName ||
          CountryName ||
          "",
    gender:
      data?.Gender || EKYCdata?.GENDER || kycDetails?.Gender || Gender || "",
    maritalStatus: data?.MaritalStatus || "",
    fatherName: data?.FatherFirstName || EKYCdata?.FATHER_FULLNAME || "",
    motherName: data?.MotherFirstName || EKYCdata?.MOTHER_FULLNAME || "",
    pranName: String(data?.PranTitleID) || "",
    occupationDetails: "",
    spouseName: data?.SpouceFirstName || "",
  };

  const validationSchema = Yup.object().shape({
    status: Yup.string().required("Status of Residence is required"),
    pan: Yup.string()
      .required("PAN is required")
      .matches(/^[A-Z]{3}[P][A-Z]{1}[0-9]{4}[A-Z]{1}$/, "Invalid PAN"),
    dob: Yup.string().required("Date of Birth is required"),
    mobile: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[6-9]{1}[0-9]{9}$/, "Invalid Mobile Number"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Invalid Email"
      ),
    name: Yup.string().required("Name is required"),
    occupation: Yup.string().required("Occupation is required"),
    place: Yup.string().required("Place of Birth is required"),
    nationality: Yup.string().required("Nationality is required"),
    country: Yup.string().required("Country of Birth is required"),
    gender: Yup.string().required("Gender is required"),
    maritalStatus: Yup.string().required("Marital status is required"),
    fatherName: Yup.string().when("pranName", (pranName, schema) => {
      return +pranName === 1
        ? schema
            .required("Father's Name is required")
            .matches(/^[a-zA-Z ]{4,50}$/, "Enter a valid name")
        : schema;
    }),
    motherName: Yup.string().when("pranName", (pranName, schema) => {
      return +pranName === 2
        ? schema
            .required("Mother's Name is required")
            .matches(/^[a-zA-Z ]{4,50}$/, "Enter a valid name")
        : schema;
    }),
    pranName: Yup.string().oneOf(
      pranNameOptions.map((o) => o.value + ""),
      "Choose mother's or father's name"
    ),
    spouseName: Yup.string().when("maritalStatus", (maritalStatus, schema) => {
      return +maritalStatus === 1
        ? schema
            .required("Spouse's Name is required")
            .matches(/^[a-zA-Z ]{4,50}$/, "Enter a valid name")
        : schema;
    }),
    occupationDetails: Yup.string().when("occupation", (occupation, schema) => {
      return +occupation === 29
        ? schema.required("Occupation Detail is required")
        : schema;
    }),
  });

  const ref = useRef();

  const submitBasicDetails = async (requestBody) => {
    try {
      if (ackNumber) return ackNumber;

      const response = await dispatch(saveBasicDetails(requestBody));
      if (Number(response.statusCode) !== SUCCESS_RESPONSE_CODE)
        throw new Error(response.message || "Error Saving Basic Details");

      const basicDetails = {
        ackNumber: response.data,
        email: requestBody.Email,
        mobileNumber: requestBody.MobileNo,
        mobileCountryCode: "+91",
        name: requestBody.FullName,
      };
      dispatchContext(setBasicDetails(basicDetails));
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.message || "Error Saving Basic Details");
      }
    } catch (error) {
      alert(error);
    }
  };

  const getPersonalDetailsRequestBody = (values) => ({
    ResidenceType: values.status,
    Gender: values.gender,
    Email: values.email,
    PANNumber: values.pan,
    CountryofBirth: values.country,
    CityofBirth: values.place,
    FullName: values.name,
    Nationality: values.nationality,
    MaritalStatus: values.maritalStatus,
    OccupationDetails: values.occupation,
    Mobile: values.mobile,
    DOB:
      typeof values.dob !== "string"
        ? format(values.dob, "dd/MM/yyyy")
        : format(new Date(values.dob), "dd/MM/yyyy"),
    PranTitleID: values.pranName,
    FatherFirstName: values.fatherName || "",
    MotherFirstName: values.motherName || "",
    ReffID: refId,
    ...(+values.maritalStatus === 1 && {
      SpouceFirstName: values.spouseName,
    }),
    ...(+values.occupation === 29 && {
      OtherOccupation: values.occupationDetails,
    }),
  });

  const getStateAndDistrict = async (pincode) => {
    if (!pincode) return;

    const response = await dispatch(getDetailsFromPincode({ pincode }));
    if (Number(response?.statusCode) === SUCCESS_RESPONSE_CODE) {
      return response;
    }
  };

  const submitKycDetails = async (values) => {
    try {
      const pinCode = EKYCdata?.PERM_PIN || kycBankDetails?.PinCode || PinCode;

      const res = (await getStateAndDistrict(pinCode)) || {};
      const ckycIdentifierType =
        EKYCDetails?.data?.ckyc_remarks === "OK" ? 372 : null;

      const requestBody = {
        AckNumber: values.ackNumber,
        BankName: kycBankDetails?.BankName || "NA",
        Address1:
          kycBankDetails?.Address1 || EKYCdata?.PERM_LINE1 || Address1 || "",
        Address2:
          kycBankDetails?.Address2 || Addreess2 || EKYCdata?.PERM_LINE2 || "",
        IdentifierNum:
          kycBankDetails?.IdentifierNum ||
          IdentifierNum ||
          EKYCdata?.CKYC_NO ||
          "",
        SubscriberName: values.name,
        District:
          kycBankDetails?.District ||
          District ||
          // EKYCdata?.PERM_DIST ||
          res?.data[0]?.District ||
          "",
        StateName:
          kycBankDetails?.StateName || StateName || res?.data[0]?.State || "",
        PinCode: kycBankDetails?.PinCode || PinCode || pinCode || "",
        PANNumber: kycBankDetails?.PANNumber || pan || "",
        CountryName:
          kycBankDetails?.CountryName ||
          CountryName ||
          res?.data[0]?.Country ||
          "",
        IdentifierType: aadhaarIdentifierType || ckycIdentifierType || 119,
        DOB:
          typeof values.dob !== "string"
            ? format(values.dob, "dd/MM/yyyy")
            : format(new Date(values.dob), "dd/MM/yyyy"),
        Gender: values?.gender,
      };

      const response = await dispatch(saveKycDetails(requestBody));

      if (Number(response.statusCode) !== 10000) {
        throw new Error(response?.message || "Error Saving KYC Details");
      }
    } catch (error) {
      alert(error);
    }
  };

  const dispatchBulkContext = async (AckNumber) => {
    try {
      const promiseList = [
        dispatch(getBankDetails({ AckNumber })),
        dispatch(getNomineeList({ AckNumber })),
        dispatch(getSchemeDetails({ AckNumber })),
        dispatch(getPersonalDetails({ AckNumber })),
        dispatch(getKycDetails({ AckNumber })),
        dispatch(getAccountType({ AckNumber })),
      ];

      const resolvedPromises = await Promise.all(promiseList);
      const [
        bankDetails,
        nomineeDetails,
        schemeDetails,
        personalDetails,
        kycDetails,
        accountType,
      ] = resolvedPromises;

      dispatchContext(setBankDetails(bankDetails));
      dispatchContext(setNomineeDetails(nomineeDetails));
      dispatchContext(setSchemeDetails(schemeDetails));
      dispatchContext(setPersonalDetails(personalDetails));
      dispatchContext(setKycDetails(kycDetails));
      dispatchContext(setAccountTypes(accountType));
    } catch (error) {}
  };

  const handleSubmit = async (values, formikHelpers) => {
    try {
      const { mobile, email, name } = values;
      const acknowledgmentNumber = await submitBasicDetails({
        ApplicantType: "AL",
        MobileNo: mobile,
        Email: email,
        FullName: name,
        AgentRefNumber: refId,
        MobileEmailRegstredFlag: "M",
      });

      // if (!acknowledgmentNumber) {
      //   console.log("m", acknowledgmentNumber);
      //   throw new Error("Error Saving Basic Details");
      // }

      const requestBody = {
        AckNumber: acknowledgmentNumber,
        ...getPersonalDetailsRequestBody(values),
      };

      if (acknowledgmentNumber) {
        const response = await savePersonalDetails(requestBody)(dispatch);

        if (Number(response.statusCode) !== 10000) {
          throw new Error(response?.message || "Error Saving Personal Details");
        }
        const isKycSubmitted = Boolean(kycDetails?.data?.IdentifierNum);

        if (!skipKyc && !isKycSubmitted) {
          await submitKycDetails({
            ...values,
            ackNumber: acknowledgmentNumber,
          });
        }

        await dispatchBulkContext(acknowledgmentNumber);

        if (isBackToSummary) {
          dispatchContext(setStatusBackToSummary(false));
          history.push("/nps/AddSubs/subscriber-summary");
          return;
        }
        history.push("/nps/AddSubs/fatca-details");
      }
    } catch (error) {
      alert(error?.message || error);
      const { setSubmitting } = formikHelpers;
      setSubmitting(false);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={ref}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, errors, isSubmitting }) => (
          <Form>
            <CardComponent title="PERSONAL DETAILS">
              <div className="new-investor-container">
                <FormRadioGroup
                  label="Status of Residence"
                  name="status"
                  options={residentTypeList}
                  required
                  fullWidth={true}
                  disabled={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue("status", value);
                    if (+value === 1) {
                      setFieldValue("country", "IN");
                      setFieldValue("nationality", "Indian");
                    } else {
                      setFieldValue("country", "");
                      setFieldValue("nationality", "");
                    }
                  }}
                />
                <FormTextInput
                  label="PAN"
                  name="pan"
                  placeholder="Enter PAN Number"
                  disabled={pan || EKYCdata?.PAN}
                  required
                />
                <FormDateInput
                  label="Date Of Birth"
                  name="dob"
                  placeholder="Enter Date of Birth"
                  required
                  disabled={dobb}
                />
                <FormTextInput
                  label="Full Name"
                  name="name"
                  placeholder="Enter Full Name"
                  required
                  disabled={
                    EKYCdata?.FULLNAME ||
                    data?.Name ||
                    kycDetails?.SubscriberName ||
                    SubscriberName
                  }
                  fullWidth={true}
                />
                <FormTextInput
                  label="Email ID"
                  name="email"
                  placeholder="Enter Email"
                  required
                  disabled={
                    EKYCdata?.EMAIL ||
                    // email ||
                    data?.Email ||
                    kycKtrackDetails.email
                  }
                />
                <FormTextInput
                  label="Mobile Number"
                  name="mobile"
                  placeholder="Enter Mobile Number"
                  required
                  disabled={
                    EKYCdata?.MOB_NUM || kycKtrackDetails.mobile || data?.Mobile
                  }
                />
                <FormSelectInput
                  label="Occupation"
                  name="occupation"
                  options={occupationOptions}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue("occupation", value);
                  }}
                  required
                />
                {+values.occupation === 29 && (
                  <FormTextInput
                    label="Occupation Details"
                    name="occupationDetails"
                    required
                  />
                )}
                <FormTextInput label="Place of Birth" name="place" required />
                <FormTextInput
                  label="Nationality"
                  name="nationality"
                  disabled={+values.status === 1}
                  required
                />
                <FormSelectInput
                  label="Country of Birth"
                  name="country"
                  options={countryList}
                  disabled={+values.status === 1}
                  required
                />
                <FormRadioGroup
                  label="Gender"
                  name="gender"
                  options={genderOptions}
                  required
                  fullWidth={false}
                  // disabled={
                  //   EKYCdata?.GENDER || data?.Gender || kycDetails?.Gender
                  // }
                />
                <FormRadioGroup
                  label="Marital Status"
                  name="maritalStatus"
                  options={maritalStatusOptions}
                  required
                  fullWidth={false}
                />
                {+values.maritalStatus === 1 && (
                  <FormTextInput
                    label="Spouse's Name"
                    name="spouseName"
                    required
                  />
                )}
                <FormTextInput
                  label="Father's Name"
                  name="fatherName"
                  required={+values.pranName === 1}
                />
                <FormTextInput
                  label="Mother's Name"
                  name="motherName"
                  required={+values.pranName === 2}
                />
                <FormRadioGroup
                  label="Name to be printed on PRAN Card"
                  name="pranName"
                  options={pranNameOptions}
                  required
                  fullWidth={true}
                />
              </div>
            </CardComponent>
            <>
              <div className="d-flex justify-content-center">
                {EKYCDetails?.data?.ckyc_remarks == "OK" ? (
                  <></>
                ) : (
                  <button
                    className="new-investor-button"
                    onClick={goBack}
                    disabled={!goBack}
                    style={{ border: "1px solid #007ac8", color: "#007ac8" }}
                  >
                    Back
                  </button>
                )}
                <button
                  type="submit"
                  className="new-investor-button new-investor-active"
                  disabled={isSubmitting}
                >
                  Proceed
                </button>
              </div>
            </>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PersonalDetails;

// const _handleSubmit = async (values) => {
//   let responseB = null;
//   if (!ackNumber) {
//     const basicDetailParam = {
//       ApplicantType: "AL",
//       MobileNo: values.mobile,
//       Email: values.email,
//       FullName: values.name,
//       AgentRefNumber: refId,
//       MobileEmailRegstredFlag: "M",
//     };
//     responseB = await dispatch(saveBasicDetails(basicDetailParam));
//     if (Number(responseB.statusCode) === 10000) {
//       dispatchContext(
//         setBasicDetails({
//           mobileNumber: values.mobile,
//           mobileCountryCode: "+91",
//           email: values.email,
//           name: values.name,
//           ackNumber: responseB.data,
//         })
//       );
//     } else {
//       // return alert(responseB.message);
//     }
//   }

//   try {
//     dispatch(showLoader());
//     const personalDetailsRequestBody = {
//       AckNumber: ackNumber || responseB.data,
//       ResidenceType: values.status,
//       Gender: values.gender,
//       Email: values.email,
//       PANNumber: values.pan,
//       CountryofBirth: values.country,
//       CityofBirth: values.place,
//       FullName: values.name,
//       Nationality: values.nationality,
//       MaritalStatus: values.maritalStatus,
//       OccupationDetails: values.occupation,
//       Mobile: values.mobile,
//       DOB:
//         typeof values.dob !== "string"
//           ? format(values.dob, "dd/MM/yyyy")
//           : format(new Date(values.dob), "dd/MM/yyyy"),
//       PranTitleID: values.pranName,
//       FatherFirstName: values.fatherName || "",
//       MotherFirstName: values.motherName || "",
//       ReffID: refId,
//       ...(+values.maritalStatus === 1 && {
//         SpouceFirstName: values.spouseName,
//       }),
//       ...(+values.occupation === 29 && {
//         OtherOccupation: values.occupationDetails,
//       }),
//     };
//     const response = await dispatch(
//       savePersonalDetails(personalDetailsRequestBody)
//     );
//     if (Number(response.statusCode) === 10000) {
//       try {
//         if (responseB || ackNumber) {
//           let IdentifierNo = null;

//           if (EKYCDetails?.data?.ckyc_remarks == "OK") {
//             IdentifierNo = 372;
//           }

//           let pin = EKYCdata?.PERM_PIN;

//           let res =
//             !!pin &&
//             (await dispatch(getDetailsFromPincode({ pincode: pin })));

//           const params = {
//             AckNumber: ackNumber || responseB.data,
//             BankName: kycBankDetails?.BankName || "NA",
//             Address1:
//               kycBankDetails?.Address1 ||
//               EKYCdata?.PERM_LINE1 ||
//               Address1 ||
//               "",
//             Address2:
//               kycBankDetails?.Address2 ||
//               Addreess2 ||
//               EKYCdata?.PERM_LINE2 ||
//               "",
//             IdentifierNum:
//               kycBankDetails?.IdentifierNum ||
//               IdentifierNum ||
//               EKYCdata?.CKYC_NO ||
//               "",
//             SubscriberName:
//               kycBankDetails?.SubscriberName ||
//               SubscriberName ||
//               EKYCdata?.FULLNAME ||
//               values.name ||
//               "",
//             District:
//               kycBankDetails?.District ||
//               District ||
//               // EKYCdata?.PERM_DIST ||
//               res?.data[0]?.District ||
//               "",
//             StateName:
//               kycBankDetails?.StateName ||
//               StateName ||
//               // EKYCdata?.PERM_STATE ||
//               res?.data[0]?.State ||
//               "",
//             PinCode: kycBankDetails?.PinCode || PinCode || pin || "",
//             PANNumber: kycBankDetails?.PANNumber || pan || "",
//             CountryName:
//               kycBankDetails?.CountryName ||
//               CountryName ||
//               // EKYCdata?.PERM_COUNTRY ||
//               res?.data[0]?.Country ||
//               "",
//             IdentifierType: IdentifierType || IdentifierNo || 119,
//             DOB:
//               typeof values.dob !== "string"
//                 ? format(values.dob, "dd/MM/yyyy")
//                 : format(new Date(values.dob), "dd/MM/yyyy"),
//             Gender: Gender || values?.gender || "",
//           };
//           if (!skipKyc && !Boolean(IdentifierNum)) {
//             const res = await dispatch(saveKycDetails(params));

//             if (Number(res?.statusCode) === 10001) {
//               return alert(res?.message);
//             }
//           }

//           try {
//             const promiseList = [
//               dispatch(getBankDetails({ AckNumber: responseB.data })),
//               dispatch(getNomineeList({ AckNumber: responseB.data })),
//               dispatch(getSchemeDetails({ AckNumber: responseB.data })),
//               dispatch(getFundChoices()),
//               dispatch(getKycDetails({ AckNumber: responseB.data })),
//               dispatch(getAccountType({ AckNumber: responseB.data })),
//             ];
//             dispatch(showLoader());
//             const bulkDetails = await Promise.all(promiseList);
//             dispatchContext(setBankDetails(bulkDetails[0]));
//             dispatchContext(setNomineeDetails(bulkDetails[1]));
//             dispatchContext(setSchemeDetails(bulkDetails[2]));
//             dispatchContext(setFundDetails(bulkDetails[3]));
//             dispatchContext(setKycDetails(bulkDetails[4]));
//             dispatchContext(setAccountTypes(bulkDetails[5]));
//           } catch (error) {
//             console.error(error);
//           } finally {
//             dispatch(hideLoader());
//           }
//         }
//       } catch (e) {
//         // alert(response.message);
//       }
//       isBackToSummary && dispatchContext(setStatusBackToSummary(false));
//       isBackToSummary
//         ? history.push({
//             pathname: "/nps/AddSubs/subscriber-summary",
//           })
//         : history.push({
//             pathname: "/nps/AddSubs/fatca-details",
//           });
//     } else {
//       // alert(response.message);
//     }
//   } catch (error) {
//     alert(error);
//   } finally {
//     dispatch(hideLoader());
//   }
// };
